import React from 'react';
export default () => React.createElement("hr", { className: 'overflow-menu-hr' });
